export const workQueueOtherPatientReportsSectionSelectors = {
  resolveAllPatientReportsButton: 'resolve-all-patient-reports-button',
  resolveAllPatientReportsPopup: 'resolve-all-patient-reports-popup',
  resolveAllPatientReportsPopupSubmitButton: 'popup-submit-btn-resolve-all-patient-reports-popup'
};
